import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { useNavigate } from 'react-router-dom';

// Shown for unknown URLs inside the signed-in app instead of a silent redirect.
const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1.5,
        px: 2,
      }}
    >
      <SearchOffIcon sx={{ fontSize: 64, color: 'primary.main', opacity: 0.7 }} />
      <Typography variant="h4" sx={{ fontWeight: 700 }}>Page not found</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420 }}>
        No clues here. This page doesn't exist or has moved.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/dashboard')} sx={{ mt: 1, textTransform: 'none', fontWeight: 600, borderRadius: 2 }}>
        Go to dashboard
      </Button>
    </Box>
  );
};

export default NotFound;
